export const validateCompanyForm = (formData) => {
  let valid = true;
  const errors = {};
  // console.log(")(()(",formData)
  const nameRegex = /^[a-zA-Z\s'.,!?]+$/;
  const addressRegex = /^[a-zA-Z0-9\s',#]+$/;

  // Accepts international phone numbers: optional +, digits/spaces/dashes/dots/parens, 7–25 chars
  const phoneRegex = /^\+?[\d\s\-().]{7,25}$/;

  if (formData.name.trim() === "") {
    errors.name = "name is required";
    valid = false;
  } else if (!nameRegex.test(formData.name.trim())) {
    errors.name = "Name is invalid";
    valid = false;
  }

  if (!formData.email) {
    errors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Email is invalid";
  }
  if (formData.address.trim() === "") {
    errors.address = "Address is required";
    valid = false;
  } else if (!addressRegex.test(formData.address.trim())) {
    errors.address = "Address is invalid";
    valid = false;
  }
  if (!formData.phone) {
    errors.phone = "Phone Number is required";
    valid = false;
  } else if (!phoneRegex.test(formData.phone)) {
    errors.phone =
      "Phone number must be 7–25 characters (digits, spaces, +, -, ., parentheses allowed):";
    valid = false;
    console.log(valid, "=-");
  }
  if (formData.fax.trim() === "") {
    // errors.fax = "fax is required";
    valid = true;
  } else if (!phoneRegex.test(formData.fax.trim())) {
    errors.fax = "Fax number must be 7–25 characters (digits, spaces, +, -, ., parentheses allowed):";
    valid = false;
    console.log(valid);
  }
  return errors;
};
